(() => {
  
  window.theme.cart.progressBar = 0;
  const e = () => {
    const e = document.querySelector("#shipping-progress-bar");
    e &&
      ((e.style.width = window.theme.cart.progressBar + "%"),
      e.classList.add("on-transition"),
      setTimeout(() => {
        (window.theme.cart.progressBar = e.dataset.width),
          (e.style.width = window.theme.cart.progressBar + "%");
      }, 10));
  };
  
  // Greeting Card Modal Initialization
  const initGreetingCardModal = () => {
    const modal = document.getElementById('greeting-card-modal');
    const trigger = document.getElementById('premium-card-trigger');
    const mainWrapper = document.querySelector('.premium-card-wrapper');
    
    if (!modal || !trigger) return;
    
    // Check if greeting card is already in cart
    const hasGreetingCardInCart = () => {
      const cartItems = document.querySelectorAll('.cart-item');
      if (!window.greetingCardData || !window.greetingCardData.productId) return false;
      
      for (let item of cartItems) {
        const productId = item.dataset.productId;
        if (productId && parseInt(productId) === window.greetingCardData.productId) {
          return true;
        }
      }
      return false;
    };
    
    // Hide/show main wrapper based on cart contents
    if (mainWrapper) {
      if (hasGreetingCardInCart()) {
        mainWrapper.style.display = 'none';
      } else {
        mainWrapper.style.display = 'block';
      }
    }
    
    const backdrop = modal.querySelector('.greeting-card-modal__backdrop');
    const closeBtn = modal.querySelector('.greeting-card-modal__close');
    const screen1 = document.getElementById('greeting-card-screen-1');
    const screen2 = document.getElementById('greeting-card-screen-2');
    const backBtn = modal.querySelector('.greeting-card-back-btn');
    const variants = modal.querySelectorAll('.greeting-card-variant');
    
    let selectedVariant = null;
    
    function openModal() {
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      showScreen(1);
    }
    
    function closeModal() {
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
      showScreen(1);
      resetForm();
    }
    
    function showScreen(screenNumber) {
      if (screenNumber === 1) {
        screen1.style.display = 'block';
        screen2.style.display = 'none';
      } else {
        screen1.style.display = 'none';
        screen2.style.display = 'block';
      }
    }
    
    function resetForm() {
      document.getElementById('greetingCardMessage').value = '';
      document.getElementById('greeting-card-preview-text').textContent = '';
      document.getElementById('message-char-count').textContent = '0';
      selectedVariant = null;
      
      // Reset button price
      const addToCartBtn = document.getElementById('add-greeting-card-btn');
      if (addToCartBtn) {
        const priceSpan = addToCartBtn.querySelector('.greeting-card-price');
        if (priceSpan) {
          priceSpan.textContent = '';
        }
      }
    }
    
    // Remove any existing listeners by cloning elements
    const newTrigger = trigger.cloneNode(true);
    trigger.parentNode.replaceChild(newTrigger, trigger);
    
    // Open modal when trigger is clicked
    newTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });
    
    // Close modal when clicking backdrop
    if (backdrop) {
      const newBackdrop = backdrop.cloneNode(true);
      backdrop.parentNode.replaceChild(newBackdrop, backdrop);
      newBackdrop.addEventListener('click', closeModal);
    }
    
    // Close modal when clicking close button
    if (closeBtn) {
      const newCloseBtn = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
      newCloseBtn.addEventListener('click', closeModal);
    }
    
    // Back button
    if (backBtn) {
      const newBackBtn = backBtn.cloneNode(true);
      backBtn.parentNode.replaceChild(newBackBtn, backBtn);
      newBackBtn.addEventListener('click', function() {
        showScreen(1);
      });
    }
    
    // Variant selection
    variants.forEach(variant => {
      variant.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        
        // Find the variant data from window.greetingCardData
        const variantData = window.greetingCardData.variants.find(v => v.id == variantId);
        
        selectedVariant = {
          id: variantId,
          title: this.dataset.variantTitle,
          images: variantData ? variantData.images : [],
          price: this.dataset.variantPrice,
          sku: variantData ? variantData.sku : ''
        };
        
        // Update screen 2 with selected variant - set both images
        const firstImage = selectedVariant.images.length > 0 ? selectedVariant.images[0] : '';
        document.getElementById('greeting-card-thumb-0').src = firstImage;
        document.getElementById('greeting-card-thumb-1').src = window.greetingCardData.placeholderImage;
        
        // Update button price
        const addToCartBtn = document.getElementById('add-greeting-card-btn');
        const priceSpan = addToCartBtn.querySelector('.greeting-card-price');
        if (priceSpan) {
          // Format price from cents to dollars
          const priceInDollars = (parseInt(selectedVariant.price) / 100).toFixed(2);
          priceSpan.textContent = '| $' + priceInDollars;
        }
        
        // Set to second thumbnail (personalization preview) by default
        const thumbnails = modal.querySelectorAll('.greeting-card-thumbnail');
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        thumbnails[1].classList.add('active');
        
        // Show placeholder image with preview overlay
        document.getElementById('greeting-card-main-img').src = window.greetingCardData.placeholderImage;
        document.getElementById('greeting-card-preview-overlay').style.display = 'flex';
        updatePreview();
        
        showScreen(2);
      });
    });
    
    // Thumbnail navigation
    const thumbnails = modal.querySelectorAll('.greeting-card-thumbnail');
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const index = parseInt(this.dataset.index);
        
        // Update active state
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        this.classList.add('active');
        
        // Update main image and show/hide preview overlay
        const mainImg = document.getElementById('greeting-card-main-img');
        const overlay = document.getElementById('greeting-card-preview-overlay');
        
        if (index === 0) {
          // Show card front - get image from the thumbnail's src
          const thumbImg = this.querySelector('img');
          mainImg.src = thumbImg ? thumbImg.src : '';
          overlay.style.display = 'none';
        } else {
          // Show blank card with text preview (placeholder image)
          mainImg.src = window.greetingCardData.placeholderImage;
          overlay.style.display = 'flex';
          updatePreview();
        }
      });
    });
    
    // Personalization: Message input
    const messageInput = document.getElementById('greetingCardMessage');
    if (messageInput) {
      messageInput.addEventListener('input', function() {
        const count = this.value.length;
        document.getElementById('message-char-count').textContent = count;
        updatePreview();
        // Hide error when user starts typing
        hideError();
      });
    }
    
    // Error message helper functions
    function showError(message) {
      const errorDiv = document.getElementById('greeting-card-error');
      if (errorDiv) {
        errorDiv.textContent = message;
        errorDiv.style.display = 'block';
        // Auto-hide after 5 seconds
        setTimeout(() => {
          hideError();
        }, 5000);
      }
    }
    
    function hideError() {
      const errorDiv = document.getElementById('greeting-card-error');
      if (errorDiv) {
        errorDiv.style.display = 'none';
      }
    }
    
    // Update preview function
    function updatePreview() {
      const message = document.getElementById('greetingCardMessage').value;
      const fontInput = document.getElementById('card-font');
      const font = fontInput ? fontInput.value : 'Cambria';
      const colorInput = document.getElementById('card-color');
      const colorHex = colorInput ? colorInput.dataset.hex : '#000000';
      const alignInput = document.getElementById('card-align');
      const align = alignInput ? alignInput.value : 'left';
      
      const previewText = document.getElementById('greeting-card-preview-text');
      previewText.textContent = message || 'Your message will appear here...';
      previewText.style.fontFamily = font + ', serif';
      previewText.style.fontSize = '12px';
      previewText.style.color = colorHex;
      previewText.style.textAlign = align;
    }
    
    // Add to cart button
    const addToCartBtn = document.getElementById('add-greeting-card-btn');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        // Clear any existing errors
        hideError();
        
        if (!selectedVariant) {
          showError('Please select a card design first.');
          return;
        }
        
        const message = document.getElementById('greetingCardMessage').value;
        const fontInput = document.getElementById('card-font');
        const font = fontInput ? fontInput.value : 'Cambria';
        const colorInput = document.getElementById('card-color');
        const color = colorInput ? colorInput.value : 'Black';
        const alignInput = document.getElementById('card-align');
        const align = alignInput ? alignInput.value : 'left';
        
        if (!message) {
          showError('Please enter a message for your card.');
          return;
        }
        
        // Prepare cart note
        let customerNote = 'GREETING CARD DETAILS:\n';
        customerNote += 'Card Design: ' + selectedVariant.title + '\n';
        customerNote += 'SKU: ' + (selectedVariant.sku || '') + '\n';
        customerNote += 'Message: ' + message + '\n';
        customerNote += 'Font: ' + font + '\n';
        customerNote += 'Color: ' + color + '\n';
        customerNote += 'Alignment: ' + align + '\n';
        
        // Temporary log to verify customer notes
        console.log('Customer Note:', customerNote);
        
        // Add to cart
        addToCartBtn.disabled = true;
        const originalHTML = addToCartBtn.innerHTML;
        addToCartBtn.innerHTML = '<span>Adding...</span>';
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: selectedVariant.id,
            quantity: 1,
            properties: {
              'Card SKU': selectedVariant.sku || '',
              'Card Message': message,
              'Card Font': font,
              'Text Color': color,
              'Text Alignment': align
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          // Update cart note
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: customerNote
            })
          });
        })
        .then(response => response.json())
        .then(data => {
          // Render cart and close modal
          window.theme.cart.render(!0);
          closeModal();
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = originalHTML;
        })
        .catch(error => {
          console.error('Error adding greeting card:', error);
          showError('There was an error adding the card to your cart. Please try again.');
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = originalHTML;
        });
      });
    }
    
    // Close modal on ESC key
    const escHandler = function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    };
    
    document.removeEventListener('keydown', escHandler);
    document.addEventListener('keydown', escHandler);
  };
  e(),
    (window.theme.cart.render = async (t = false, r = false) => {
      const s = await fetch("/?section_id=cart-drawer", {
        headers: { "Cache-Control": "no-cache" },
      }).then((e) => e.text());
      s.includes("Your Cart is empty") && (window.theme.cart.progressBar = 0);
      const a = new DOMParser()
        .parseFromString(s, "text/html")
        .querySelector(".shopify-section");
      (document.getElementById("cart-drawer_wrapper").innerHTML = a.innerHTML),
        window.theme.cart.toggle(r, t),
        e(),
        initGreetingCardModal(),
        Shopify?.cartUpsellsApp &&
          Shopify.cartUpsellsApp.init({ sliderSelector: ".cart-upsells" });
    });
    
  
   function updateHeight() {
      const cartItemsWrapper = document.querySelector(".cart-items-wrapper");
      const cartFooter = document.querySelector(".cart__footer");
      const cartTitleWrapper = document.querySelector(".cart__title-wrapper");
      const windowHeight = window.innerHeight;
      const footerHeight = cartFooter.offsetHeight;
      const titleWrapperHeight = cartTitleWrapper.offsetHeight;
      const itemsWrapperHeight = windowHeight - footerHeight - titleWrapperHeight;
      // cartItemsWrapper.style.paddingTop = `${titleWrapperHeight + 15}px`;
      cartItemsWrapper.style.height = `${itemsWrapperHeight}px`;

      window.igEvents = window.igEvents || [];
      // Add your event to the igEvents array
      window.igEvents.push({
        "event": "javascripteventNXMVI", // Do not remove - required for tracking
      })

    }
   
  class t extends HTMLElement {
    mainDetailsToggle;
    insuranceModal;
    insuranceCheckbox;
    wrapper;
    drawer;
    constructor() {
      super(),
        (this.mainDetailsToggle = this.querySelector("details")),
        (this.insuranceModal = document.querySelector("#modal-insurance")),
        (this.insuranceCheckbox = document.querySelector("#bearabyInsurance")),
        (this.wrapper = this.children[0]),
        (this.drawer = this.querySelector("#cart-drawer")),
        this.querySelector(".info-insurance") &&
          this.querySelector(".info-insurance").addEventListener(
            "click",
            this.openInsurance.bind(this)
          ),
        this.querySelector(".cart__product-upsell") && this.handleCartUpsell();
    }
   
    handleCartUpsell() {
      const e = this.querySelector(".cart__product-upsell"),
        t = this.querySelector(".btn"),
        r = e.querySelectorAll(".cart__product-upsell-dropdown"),
        s = e.querySelector(".cart__product-upsell-image img"),
        a = e.querySelector(".cart__product-upsell-option:first-child small"),
        n = e.querySelector(".cart__product-upsell-option:last-child small"),
        i = e.querySelector(".cart__product-upsell-price"),
        c = e.querySelector('[name="hugget_id"]');
      e.addEventListener("change", function (t) {
        t.target
          .closest(".cart__product-upsell-dropdown")
          .classList.toggle("active");
        const r = t.target.id.includes("hugget-color") ? "color" : "size",
          o = e.querySelector('[name="hugget_color"]:checked').value,
          l = e.querySelector('[name="hugget_size"]:checked').value,
          d = {};
        for (let e = 0; e < c.options.length; e++) {
          const s = c.options[e];
          s.dataset.color === o && s.dataset.size === l
            ? (d.exact = s)
            : s.dataset[r] !== t.target.value || d.closest || (d.closest = s);
        }
        const h = d.exact || d.closest;
        (s.src = h.dataset.image),
          (i.dataset.price = h.dataset.price),
          (i.dataset.discounted = h.dataset.discounted),
          (a.dataset.value = h.dataset.color),
          (n.dataset.value = h.dataset.size),
          (c.value = h.value),
          (e.querySelector(
            `[name="hugget_color"][value="${h.dataset.color}"]`
          ).checked = !0),
          (e.querySelector(
            `[name="hugget_size"][value="${h.dataset.size}"]`
          ).checked = !0);
      }),
        r.forEach((e) => {
          e.addEventListener("click", () => {
            e.classList.toggle("active");
          });
        }),
        t.addEventListener("click", function () {
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  quantity: 1,
                  id: Number(c.value),
                  properties: { discount: "$10 off Huggets" },
                },
              ],
            }),
          })
            .then((e) => e.json())
            .then((e) => {
              window.theme.cart.render();
            })
            .catch((e) => {
              alert("there has been an error"), console.err(e);
            });
        });
    }
    closeInsurance(e) {
      e.preventDefault(),
        this.insuranceModal.removeAttribute("open"),
        this.drawer.setAttribute("open", "");
    }
    openInsurance(e) {
      e.preventDefault(),
        this.insuranceModal.setAttribute("open", ""),
        this.drawer.removeAttribute("open");
    }
  }
  customElements.define("cart-drawer", t);
  class r extends HTMLElement {
    constructor() {
      super(),
        this.addEventListener("click", (e) => {
          e.preventDefault();
          const t = this.closest("cart-items");
          if (this.hasAttribute("data-bundle")) {
            const e = this.dataset.bundle.split(","),
              r = this.closest(".cart-item");
            t.removeBundle(e[0], e[1], r);
          } else t.updateQuantity(this.dataset.index, 0);
        });
    }
  }
  customElements.define("cart-remove-button", r);
  class s extends HTMLElement {
    wrapper;
    form;
    insurance;
    constructor() {
      super(),
        (this.wrapper = this.querySelector("#main-cart-items")),
        (this.form = this.querySelector("form")),
        (this.insurance = this.querySelector('[name="insurance"]')),
        this.wrapper &&
          (this.wrapper.addEventListener("change", this.onChange.bind(this)),
          this.form.addEventListener("submit", this.handleSubmit.bind(this)),
          this.form.dataset.insurance && this.removeInsurance(),
          updateHeight()
        );
    }
    onChange(e) {
      this.updateQuantity(e.target.dataset.index, e.target.value);
      updateHeight();
    }
    updateQuantity(e, t) {
      const r = document.getElementById("cart");
      if (r && (r.classList.add("loading"), 0 === t)) {
        const t = r.querySelector("#CartItem-" + e);
        t && t.classList.add("cart-item-remove");
      }
      const s = JSON.stringify({ line: e, quantity: t });
      fetch("/cart/change", { ...window.theme.fetchConfig(), body: s })
        .then((e) => e.text())
        .then((e) => {
          JSON.parse(e), window.theme.cart.render();
        })
        .catch((e) => {
          console.warn(e);
        })
        .finally(() => {
          r && r.classList.remove("loading");
        });
    }
    removeBundle(e, t, r) {
      const s = document.getElementById("cart");
      s &&
        (s.classList.add("loading"), r && r.classList.add("cart-item-remove"));
      let a = {};
      (a[e] = 0), (a[t] = 0);
      const n = JSON.stringify({ updates: a });
      fetch("/cart/update", { ...window.theme.fetchConfig(), body: n })
        .then((e) => e.text())
        .then((e) => {
          JSON.parse(e), window.theme.cart.render();
        })
        .catch((e) => {
          console.warn(e);
        })
        .finally(() => {
          s && s.classList.remove("loading");
        });
    }
    handleSubmit(e) {
      if (
        (e.preventDefault(),
        this.form.classList.add("loading"),
        (this.form.querySelector("#checkout").disabled = !0),
        !this.insurance || !this.insurance.checked)
      )
        return void (location.href = "/checkout");
      const t = JSON.stringify({
        id: this.insurance.value,
        quantity: Number(this.insurance.dataset.quantity),
      });
      fetch("/cart/add", { ...window.theme.fetchConfig(), body: t })
        .then(() => {
          location.href = "/checkout";
        })
        .catch((t) => {
          console.error(t), e.target.submit();
        });
    }
    removeInsurance() {
      const e = JSON.stringify({
        id: this.form.dataset.insurance,
        quantity: 0,
      });
      fetch("/cart/change", { ...window.theme.fetchConfig(), body: e })
        .then((e) => e.json())
        .then((e) => {
          window.theme.cart.render();
        })
        .catch((e) => {
          console.warn(e);
        });
    }
  }
  customElements.define("cart-items", s);
  class a extends HTMLElement {
    textArea;
    characters;
    form;
    constructor() {
      super(),
        (this.textArea = this.querySelector("textarea")),
        (this.characters = this.querySelector(".note_characters span")),
        (this.form = document.querySelector("#cart")),
        this.textArea.addEventListener(
          "keyup",
          this.changeCharacters.bind(this)
        ),
        this.addEventListener("click", this.handleNote.bind(this));
    }
    changeCharacters() {
      const e = 200 - this.textArea.value.length;
      this.characters.innerHTML = e.toString();
    }
    handleNote(e) {
      e.preventDefault();
      let t = "";
      if ("BUTTON" !== e.target.tagName) return;
      if ("trigger" === e.target.dataset.note)
        return void (this.hasAttribute("open")
          ? this.removeAttribute("open")
          : this.setAttribute("open", ""));
      "add" === e.target.dataset.note && (t = this.textArea.value),
        this.form.classList.add("loading");
      const r = JSON.stringify({ note: t });
      fetch("/cart/update", { ...window.theme.fetchConfig(), body: r })
        .then((e) => e.text())
        .then((e) => {
          JSON.parse(e), window.theme.cart.render();
        })
        .catch((e) => {
          console.warn(e);
        })
        .finally(() => {
          this.form.classList.remove("loading");
        });
    }
  }
  customElements.define("note-drawer", a);
  class n extends HTMLElement {
    button;
    image;
    color;
    form;
    constructor() {
      super(),
        (this.button = this.querySelector("button")),
        (this.image = this.querySelector(".cross-sell_image")),
        (this.color = this.querySelector(".cross-sell_color")),
        (this.form = document.querySelector("#cart")),
        this.addEventListener("change", this.changeColor.bind(this)),
        this.button.addEventListener("click", this.addCross.bind(this));
    }
    changeColor(e) {
      const t = e.target;
      (this.image.src = t.dataset.image),
        (this.color.innerHTML = t.dataset.color);
    }
    addCross(e) {
      e.preventDefault(), this.form.classList.add("loading");
      const t = this.querySelector("input:checked").value,
        r = JSON.stringify({ id: t });
      fetch("/cart/add", { ...window.theme.fetchConfig(), body: r })
        .then((e) => e.json())
        .then((e) => {
          window.theme.cart.render();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.form.classList.remove("loading");
        });
    }
  }
  customElements.define("cross-sell", n);
  class i extends HTMLElement {
    input;
    constructor() {
      super(),
        (this.input = this.querySelector("input")),
        this.querySelectorAll("button").forEach((e) =>
          e.addEventListener("click", this.onButtonClick.bind(this))
        );
    }
    onButtonClick(e) {
      e.preventDefault(),
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown();
      const t = this.closest("cart-items"),
        r = this.closest("product-form");
      if (t)
        t.updateQuantity(this.input.dataset.index, parseInt(this.input.value));
      else if (
        r.querySelectorAll("[data-unit-price]") &&
        this.dataset.changePrice
      ) {
        const e = r.querySelectorAll("[data-unit-price]"),
          t = parseInt(this.input.value);
        e.forEach((e) => {
          const r = parseInt(e.dataset.unitPrice.replace("$", ""));
          e.dataset.mobilePrice = "$" + r * t;
        });
      }
    }
  }
  customElements.define("quantity-input", i), window.theme.cart.render(!1, !0);
  
  // Initialize greeting card modal on page load
  initGreetingCardModal();
  console.log('Greeting card modal initialized');
})();
